import {
  DAYS_BEFORE_EXPIRE_KEY,
  IS_FIRST_CONNECTION_KEY,
  IUserInformationsWebServiceClient,
  UserInformations
} from "@resources/resources";
import {Injectable} from "@angular/core";
import {CanActivate} from "@angular/router";
import {CerbaAuthService, CerbaCookieService, CookieConstantes, UserStore} from "@digicerba/common";

@Injectable()
export class UserGuardAndResolve implements CanActivate {

  constructor(private iUserInformationsWebServiceClient: IUserInformationsWebServiceClient,
              private userStore: UserStore, private cerbaAuthService: CerbaAuthService, private cookieService: CerbaCookieService) {
  }

  canActivate() {
    const authCookieValue = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_AUTH);

    if (authCookieValue) {
      try {
        let userCall = this.iUserInformationsWebServiceClient.me();
        return userCall.map(user => {
          this.userStore.setUser(user);
          localStorage.setItem(DAYS_BEFORE_EXPIRE_KEY, user.daysBeforeExpire+'');
          localStorage.setItem(IS_FIRST_CONNECTION_KEY ,user.firstConnection+'');
          return true;
        });
      }
      catch (e) {
        console.log('no me.' + e);
      }
    }
    else {
      this.userStore.setUser(new UserInformations());
    }

    return true;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/user.guard.ts